<template>
  <v-data-table
    :headers="headers"
    :items="items"
    class="elevation-1"      
    :search="search"
  >      
    <template v-slot:body="{ items }">
      <tbody>
        <tr v-for="item in items" :key="item.name">
          <td class="text-xs-left">{{item.name}}</td>
          <td class="text-xs-left">{{item.abbr}}</td>
          <td v-if="item.superboleto"><span class="green--text">ativado</span></td>
          <td v-else><span class="red--text">desativado</span></td>
          <td>
              <v-btn v-if="owner" @click="$emit('remove', item.id)" title="Remover loja" fab dark small color="error">
                <v-icon dark>remove</v-icon>
              </v-btn>
              <v-btn v-if="owner" @click="$emit('edit', item)" fab dark small color="cyan">
                <v-icon dark>edit</v-icon>
              </v-btn>
              <v-btn v-if="owner" @click="$emit('configure', item)" title="Configurar integração" fab dark small color="blue">
                <v-icon dark>settings</v-icon>
              </v-btn>            
              <v-switch v-if="!owner" @change="setActive(item.pivot)" v-model="item.pivot.active" label="Ativo"></v-switch>
              <v-btn v-if="!owner" @click="$emit('edit', item)" fab dark small color="cyan">
                <v-icon dark>edit</v-icon>
              </v-btn>
              <v-btn v-if="!owner"  title="Atender Loja" fab dark small color="blue">
                <v-icon dark>mdi-cash-marker</v-icon>                 
              </v-btn>            
          </td>
        </tr>
      </tbody>
    </template>
  </v-data-table>  
</template>
<script>
  export default {
    props: {
      items: {
        type: Array,
        default () {
          return [];
        }
      },
      owner: {
        type: Boolean,
        default () {
          return false;
        }
      },
    },
    methods: {
      
    },
    data () {
      return {
        search: '',
        headers: [
          {text: 'Nome', value: 'name'},
          {text: 'Sigla', value: 'abbr'},
          {text: 'Superboleto', value: 'superboleto'},
          {text: '', value: ''}
        ],
      }
    }
  }
</script>